import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Attach bearer fallback if cookies are blocked
let bearerToken = null;
export function setBearerToken(t) {
  bearerToken = t;
  if (t) localStorage.setItem("rcc_token", t);
  else localStorage.removeItem("rcc_token");
}
export function getBearerToken() {
  return bearerToken || localStorage.getItem("rcc_token");
}

api.interceptors.request.use((config) => {
  const t = getBearerToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // Inject HQ branch_scope on every GET so list endpoints respect the
  // distributor→dealer visibility rule. Mutating endpoints (POST/PATCH/DELETE)
  // are left untouched. The backend ignores the param for non-HQ users.
  try {
    const method = (config.method || "get").toLowerCase();
    if (method === "get") {
      const scope = window.localStorage.getItem("rcc_branch_scope");
      if (scope && !(config.params && config.params.branch_scope)) {
        config.params = { ...(config.params || {}), branch_scope: scope };
      }
    }
  } catch (_) { /* no-op */ }
  return config;
});

export function formatError(detail, fallback = "Something went wrong") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
